// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.participating-schools-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.participating-schools-container .input-container {
  width: 50%;
  font-weight: 500;
  font-size: 0.9rem;
  margin: 10px 0;
  display: flex;
  flex-direction: column;
}
.participating-schools-container .input-container .participating-schools-dropdown {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
  color: #444343;
}

.data-container {
  background: #A7A9AC;
  border-radius: 10px;
  padding-top: -10px;
  padding: 0 40px;
  padding-bottom: 20px;
  margin-top: 40px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
}

.save-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  padding-right: 30px;
}

.no-data-message-heading {
  padding: 5px 5px 5px 0;
  margin-top: 30px;
  margin-bottom: -20px;
  font-weight: 600;
  font-size: 1.3rem;
  font-size: 1.22rem;
}
.no-data-message-heading .bold-schoolName {
  font-weight: 700;
  font-style: italic;
  color: #63AEDE;
}
.no-data-message-heading .date-range {
  background: #FEBF31;
  border-radius: 2px;
  font-size: 1.1rem;
  margin-left: 5px;
  padding: 3px 6px;
  margin-left: 5px;
}

.no-data-message {
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Numbers.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAUJ;AARI;EACI,UAAA;ECqBJ,gBAAA;EACA,iBAAA;EACA,cAAA;EDrBI,aAAA;EACA,sBAAA;AAYR;AAVQ;ECXJ,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;EDtBQ,cDQH;ACOT;;AATA;EACI,mBDHI;EEjBJ,mBDqBsB;EACtB,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;ECJA,2CAAA;ADiBJ;;AATA;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAYJ;;AATA;EACI,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAYJ;AAVI;EACI,gBAAA;EACA,kBAAA;EACA,cDpBQ;ACgChB;AAVI;EACI,mBDrCI;EEbR,kBDmD0B;EACtB,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAYR;;AATA;EACI,gBAAA;AAYJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.participating-schools-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .input-container {\n        width: 50%;\n        @include standardInputContainer;\n        display: flex;\n        flex-direction: column;\n\n        .participating-schools-dropdown {\n            @include standardInput();\n            color: $grey4a;\n        }\n    }\n\n}\n\n.data-container {\n    background: $grey2;\n    @include borderRadius(10px);\n    padding-top: -10px;\n    padding: 0 40px;\n    padding-bottom: 20px;\n    margin-top: 40px;\n    @include shadow;\n}\n\n.save-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 50px;\n    padding-right: 30px;\n}\n\n.no-data-message-heading {\n    padding: 5px 5px 5px 0;\n    margin-top: 30px;\n    margin-bottom: -20px;\n    font-weight: 600;\n    font-size: 1.3rem;\n    font-size: 1.22rem;\n\n    .bold-schoolName {\n        font-weight: 700;\n        font-style: italic;\n        color: $lt-pearl-blue;\n    }\n    .date-range {\n        background: $important;\n        @include borderRadius(2px);\n        font-size: 1.1rem;\n        margin-left: 5px;\n        padding: 3px 6px;\n        margin-left: 5px;\n    }\n}\n.no-data-message {\n    margin-top: 30px;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
